"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArResponsePayload = exports.DifferentialPrivacyParameters = exports.OnDeviceInfo = exports.AdMetadataCacheConfig = exports.AdPosition = exports.SKAdNetworkAttribution = exports.LensPosition = exports.AdServeItem = exports.InventoryResponse = exports.AdResponse = exports.SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation = void 0;
const long_1 = __importDefault(require("long"));
const third_party_ad_network_track_info_1 = require("./track/third_party_ad_network_track_info");
const ad_insertion_config_1 = require("./ad_insertion_config");
const client_crawl_request_1 = require("./client_crawl_request");
const lens_mixer_metadata_1 = require("./lens_mixer_metadata");
const minimal_1 = __importDefault(require("protobufjs/minimal"));
const wrappers_1 = require("../../google/protobuf/wrappers");
/** Determines the type of the transformation required to interpret the sk_ad_network_attribution_signature */
var SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation;
(function (SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation) {
    /** UNSET - unset */
    SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation[SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation["UNSET"] = 0] = "UNSET";
    /** UTF8_DECODE - converts bytes to a UTF-8 string */
    SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation[SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation["UTF8_DECODE"] = 1] = "UTF8_DECODE";
    /** BASE64_ENCODE - converts bytes to a base64 encoded string */
    SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation[SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation["BASE64_ENCODE"] = 2] = "BASE64_ENCODE";
    SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation[SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation = exports.SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation || (exports.SKAdNetworkAttribution_SKAdNetworkAttributionSignatureContentTransformation = {}));
function createBaseAdResponse() {
    return { encryptedUserTrackData: new Uint8Array(), inventoryResponses: [] };
}
exports.AdResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.encryptedUserTrackData.length !== 0) {
            writer.uint32(10).bytes(message.encryptedUserTrackData);
        }
        for (const v of message.inventoryResponses) {
            exports.InventoryResponse.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.encryptedUserTrackData = reader.bytes();
                    break;
                case 2:
                    message.inventoryResponses.push(exports.InventoryResponse.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdResponse();
        message.encryptedUserTrackData =
            object.encryptedUserTrackData ?? new Uint8Array();
        message.inventoryResponses =
            object.inventoryResponses?.map((e) => exports.InventoryResponse.fromPartial(e)) ||
                [];
        return message;
    },
};
function createBaseInventoryResponse() {
    return {
        errorCode: 0,
        requestId: new Uint8Array(),
        trackUrl: "",
        trackAndGetUrl: "",
        items: [],
        waterfall: "",
        jsonTrackUrl: "",
        protoTrackUrl: "",
        batchTrackUrl: "",
        arResponsePayload: undefined,
    };
}
exports.InventoryResponse = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.errorCode !== 0) {
            writer.uint32(8).int32(message.errorCode);
        }
        if (message.requestId.length !== 0) {
            writer.uint32(18).bytes(message.requestId);
        }
        if (message.trackUrl !== "") {
            writer.uint32(26).string(message.trackUrl);
        }
        if (message.trackAndGetUrl !== "") {
            writer.uint32(34).string(message.trackAndGetUrl);
        }
        for (const v of message.items) {
            exports.AdServeItem.encode(v, writer.uint32(42).fork()).ldelim();
        }
        if (message.waterfall !== "") {
            writer.uint32(50).string(message.waterfall);
        }
        if (message.jsonTrackUrl !== "") {
            writer.uint32(58).string(message.jsonTrackUrl);
        }
        if (message.protoTrackUrl !== "") {
            writer.uint32(66).string(message.protoTrackUrl);
        }
        if (message.batchTrackUrl !== "") {
            writer.uint32(74).string(message.batchTrackUrl);
        }
        if (message.arResponsePayload !== undefined) {
            exports.ArResponsePayload.encode(message.arResponsePayload, writer.uint32(82).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseInventoryResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.errorCode = reader.int32();
                    break;
                case 2:
                    message.requestId = reader.bytes();
                    break;
                case 3:
                    message.trackUrl = reader.string();
                    break;
                case 4:
                    message.trackAndGetUrl = reader.string();
                    break;
                case 5:
                    message.items.push(exports.AdServeItem.decode(reader, reader.uint32()));
                    break;
                case 6:
                    message.waterfall = reader.string();
                    break;
                case 7:
                    message.jsonTrackUrl = reader.string();
                    break;
                case 8:
                    message.protoTrackUrl = reader.string();
                    break;
                case 9:
                    message.batchTrackUrl = reader.string();
                    break;
                case 10:
                    message.arResponsePayload = exports.ArResponsePayload.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseInventoryResponse();
        message.errorCode = object.errorCode ?? 0;
        message.requestId = object.requestId ?? new Uint8Array();
        message.trackUrl = object.trackUrl ?? "";
        message.trackAndGetUrl = object.trackAndGetUrl ?? "";
        message.items = object.items?.map((e) => exports.AdServeItem.fromPartial(e)) || [];
        message.waterfall = object.waterfall ?? "";
        message.jsonTrackUrl = object.jsonTrackUrl ?? "";
        message.protoTrackUrl = object.protoTrackUrl ?? "";
        message.batchTrackUrl = object.batchTrackUrl ?? "";
        message.arResponsePayload =
            object.arResponsePayload !== undefined &&
                object.arResponsePayload !== null
                ? exports.ArResponsePayload.fromPartial(object.arResponsePayload)
                : undefined;
        return message;
    },
};
function createBaseAdServeItem() {
    return {
        adData: new Uint8Array(),
        encryptedAdTrackData: new Uint8Array(),
        adId: new Uint8Array(),
        adPosition: undefined,
        lensPositions: [],
        serveItemId: new Uint8Array(),
        viewReceipt: new Uint8Array(),
        adRenderData: new Uint8Array(),
        adType: 0,
        demandSource: 0,
        eligibleThirdPartyAdNetworkTrackInfo: [],
        pixelId: new Uint8Array(),
        skAdNetworkAttribution: undefined,
        adMetadataCacheTtlSecs: "0",
        organicValue: 0,
        adInsertionConfig: undefined,
        serveTimestampMillis: "0",
        adMetadataCacheConfig: undefined,
        adSwipeUpLikely: false,
        onDeviceInfo: undefined,
        enableAppInstallTrackRevamp: false,
        sponsoredUnlockableType: 0,
        adSquadId: new Uint8Array(),
        campaignId: new Uint8Array(),
        adAccountId: new Uint8Array(),
        swipeProbability: 0,
        clientCrawlRequests: [],
        optimizationGoal: 0,
        lensMixerMetadata: undefined,
    };
}
exports.AdServeItem = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adData.length !== 0) {
            writer.uint32(10).bytes(message.adData);
        }
        if (message.encryptedAdTrackData.length !== 0) {
            writer.uint32(18).bytes(message.encryptedAdTrackData);
        }
        if (message.adId.length !== 0) {
            writer.uint32(26).bytes(message.adId);
        }
        if (message.adPosition !== undefined) {
            exports.AdPosition.encode(message.adPosition, writer.uint32(34).fork()).ldelim();
        }
        for (const v of message.lensPositions) {
            exports.LensPosition.encode(v, writer.uint32(218).fork()).ldelim();
        }
        if (message.serveItemId.length !== 0) {
            writer.uint32(42).bytes(message.serveItemId);
        }
        if (message.viewReceipt.length !== 0) {
            writer.uint32(50).bytes(message.viewReceipt);
        }
        if (message.adRenderData.length !== 0) {
            writer.uint32(58).bytes(message.adRenderData);
        }
        if (message.adType !== 0) {
            writer.uint32(64).int32(message.adType);
        }
        if (message.demandSource !== 0) {
            writer.uint32(80).int32(message.demandSource);
        }
        for (const v of message.eligibleThirdPartyAdNetworkTrackInfo) {
            third_party_ad_network_track_info_1.ThirdPartyAdNetworkTrackInfo.encode(v, writer.uint32(90).fork()).ldelim();
        }
        if (message.pixelId.length !== 0) {
            writer.uint32(98).bytes(message.pixelId);
        }
        if (message.skAdNetworkAttribution !== undefined) {
            exports.SKAdNetworkAttribution.encode(message.skAdNetworkAttribution, writer.uint32(106).fork()).ldelim();
        }
        if (message.adMetadataCacheTtlSecs !== "0") {
            writer.uint32(112).int64(message.adMetadataCacheTtlSecs);
        }
        if (message.organicValue !== 0) {
            writer.uint32(125).float(message.organicValue);
        }
        if (message.adInsertionConfig !== undefined) {
            ad_insertion_config_1.AdInsertionConfig.encode(message.adInsertionConfig, writer.uint32(130).fork()).ldelim();
        }
        if (message.serveTimestampMillis !== "0") {
            writer.uint32(136).int64(message.serveTimestampMillis);
        }
        if (message.adMetadataCacheConfig !== undefined) {
            exports.AdMetadataCacheConfig.encode(message.adMetadataCacheConfig, writer.uint32(146).fork()).ldelim();
        }
        if (message.adSwipeUpLikely === true) {
            writer.uint32(152).bool(message.adSwipeUpLikely);
        }
        if (message.onDeviceInfo !== undefined) {
            exports.OnDeviceInfo.encode(message.onDeviceInfo, writer.uint32(162).fork()).ldelim();
        }
        if (message.enableAppInstallTrackRevamp === true) {
            writer.uint32(168).bool(message.enableAppInstallTrackRevamp);
        }
        if (message.sponsoredUnlockableType !== 0) {
            writer.uint32(176).int32(message.sponsoredUnlockableType);
        }
        if (message.adSquadId.length !== 0) {
            writer.uint32(186).bytes(message.adSquadId);
        }
        if (message.campaignId.length !== 0) {
            writer.uint32(194).bytes(message.campaignId);
        }
        if (message.adAccountId.length !== 0) {
            writer.uint32(202).bytes(message.adAccountId);
        }
        if (message.swipeProbability !== 0) {
            writer.uint32(213).float(message.swipeProbability);
        }
        for (const v of message.clientCrawlRequests) {
            client_crawl_request_1.ClientCrawlRequest.encode(v, writer.uint32(226).fork()).ldelim();
        }
        if (message.optimizationGoal !== 0) {
            writer.uint32(232).int32(message.optimizationGoal);
        }
        if (message.lensMixerMetadata !== undefined) {
            lens_mixer_metadata_1.LensMixerMetadata.encode(message.lensMixerMetadata, writer.uint32(242).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdServeItem();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adData = reader.bytes();
                    break;
                case 2:
                    message.encryptedAdTrackData = reader.bytes();
                    break;
                case 3:
                    message.adId = reader.bytes();
                    break;
                case 4:
                    message.adPosition = exports.AdPosition.decode(reader, reader.uint32());
                    break;
                case 27:
                    message.lensPositions.push(exports.LensPosition.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.serveItemId = reader.bytes();
                    break;
                case 6:
                    message.viewReceipt = reader.bytes();
                    break;
                case 7:
                    message.adRenderData = reader.bytes();
                    break;
                case 8:
                    message.adType = reader.int32();
                    break;
                case 10:
                    message.demandSource = reader.int32();
                    break;
                case 11:
                    message.eligibleThirdPartyAdNetworkTrackInfo.push(third_party_ad_network_track_info_1.ThirdPartyAdNetworkTrackInfo.decode(reader, reader.uint32()));
                    break;
                case 12:
                    message.pixelId = reader.bytes();
                    break;
                case 13:
                    message.skAdNetworkAttribution = exports.SKAdNetworkAttribution.decode(reader, reader.uint32());
                    break;
                case 14:
                    message.adMetadataCacheTtlSecs = longToString(reader.int64());
                    break;
                case 15:
                    message.organicValue = reader.float();
                    break;
                case 16:
                    message.adInsertionConfig = ad_insertion_config_1.AdInsertionConfig.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.serveTimestampMillis = longToString(reader.int64());
                    break;
                case 18:
                    message.adMetadataCacheConfig = exports.AdMetadataCacheConfig.decode(reader, reader.uint32());
                    break;
                case 19:
                    message.adSwipeUpLikely = reader.bool();
                    break;
                case 20:
                    message.onDeviceInfo = exports.OnDeviceInfo.decode(reader, reader.uint32());
                    break;
                case 21:
                    message.enableAppInstallTrackRevamp = reader.bool();
                    break;
                case 22:
                    message.sponsoredUnlockableType = reader.int32();
                    break;
                case 23:
                    message.adSquadId = reader.bytes();
                    break;
                case 24:
                    message.campaignId = reader.bytes();
                    break;
                case 25:
                    message.adAccountId = reader.bytes();
                    break;
                case 26:
                    message.swipeProbability = reader.float();
                    break;
                case 28:
                    message.clientCrawlRequests.push(client_crawl_request_1.ClientCrawlRequest.decode(reader, reader.uint32()));
                    break;
                case 29:
                    message.optimizationGoal = reader.int32();
                    break;
                case 30:
                    message.lensMixerMetadata = lens_mixer_metadata_1.LensMixerMetadata.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdServeItem();
        message.adData = object.adData ?? new Uint8Array();
        message.encryptedAdTrackData =
            object.encryptedAdTrackData ?? new Uint8Array();
        message.adId = object.adId ?? new Uint8Array();
        message.adPosition =
            object.adPosition !== undefined && object.adPosition !== null
                ? exports.AdPosition.fromPartial(object.adPosition)
                : undefined;
        message.lensPositions =
            object.lensPositions?.map((e) => exports.LensPosition.fromPartial(e)) || [];
        message.serveItemId = object.serveItemId ?? new Uint8Array();
        message.viewReceipt = object.viewReceipt ?? new Uint8Array();
        message.adRenderData = object.adRenderData ?? new Uint8Array();
        message.adType = object.adType ?? 0;
        message.demandSource = object.demandSource ?? 0;
        message.eligibleThirdPartyAdNetworkTrackInfo =
            object.eligibleThirdPartyAdNetworkTrackInfo?.map((e) => third_party_ad_network_track_info_1.ThirdPartyAdNetworkTrackInfo.fromPartial(e)) || [];
        message.pixelId = object.pixelId ?? new Uint8Array();
        message.skAdNetworkAttribution =
            object.skAdNetworkAttribution !== undefined &&
                object.skAdNetworkAttribution !== null
                ? exports.SKAdNetworkAttribution.fromPartial(object.skAdNetworkAttribution)
                : undefined;
        message.adMetadataCacheTtlSecs = object.adMetadataCacheTtlSecs ?? "0";
        message.organicValue = object.organicValue ?? 0;
        message.adInsertionConfig =
            object.adInsertionConfig !== undefined &&
                object.adInsertionConfig !== null
                ? ad_insertion_config_1.AdInsertionConfig.fromPartial(object.adInsertionConfig)
                : undefined;
        message.serveTimestampMillis = object.serveTimestampMillis ?? "0";
        message.adMetadataCacheConfig =
            object.adMetadataCacheConfig !== undefined &&
                object.adMetadataCacheConfig !== null
                ? exports.AdMetadataCacheConfig.fromPartial(object.adMetadataCacheConfig)
                : undefined;
        message.adSwipeUpLikely = object.adSwipeUpLikely ?? false;
        message.onDeviceInfo =
            object.onDeviceInfo !== undefined && object.onDeviceInfo !== null
                ? exports.OnDeviceInfo.fromPartial(object.onDeviceInfo)
                : undefined;
        message.enableAppInstallTrackRevamp =
            object.enableAppInstallTrackRevamp ?? false;
        message.sponsoredUnlockableType = object.sponsoredUnlockableType ?? 0;
        message.adSquadId = object.adSquadId ?? new Uint8Array();
        message.campaignId = object.campaignId ?? new Uint8Array();
        message.adAccountId = object.adAccountId ?? new Uint8Array();
        message.swipeProbability = object.swipeProbability ?? 0;
        message.clientCrawlRequests =
            object.clientCrawlRequests?.map((e) => client_crawl_request_1.ClientCrawlRequest.fromPartial(e)) || [];
        message.optimizationGoal = object.optimizationGoal ?? 0;
        message.lensMixerMetadata =
            object.lensMixerMetadata !== undefined &&
                object.lensMixerMetadata !== null
                ? lens_mixer_metadata_1.LensMixerMetadata.fromPartial(object.lensMixerMetadata)
                : undefined;
        return message;
    },
};
function createBaseLensPosition() {
    return { cameraType: 0, position: 0 };
}
exports.LensPosition = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.cameraType !== 0) {
            writer.uint32(8).int32(message.cameraType);
        }
        if (message.position !== 0) {
            writer.uint32(16).int32(message.position);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLensPosition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.cameraType = reader.int32();
                    break;
                case 2:
                    message.position = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseLensPosition();
        message.cameraType = object.cameraType ?? 0;
        message.position = object.position ?? 0;
        return message;
    },
};
function createBaseSKAdNetworkAttribution() {
    return {
        skAdNetworkVersion: "",
        skAdNetworkCampaignIdentifier: undefined,
        skAdNetworkTimestampMs: undefined,
        skAdNetworkNonce: new Uint8Array(),
        skAdNetworkAttributionSignature: new Uint8Array(),
        signatureContentTransformation: 0,
        skAdNetworkViewThroughVersion: "",
        skAdNetworkViewThroughNonce: new Uint8Array(),
        skAdNetworkViewThroughAttributionSignature: new Uint8Array(),
        skAdNetworkSourceIdentifier: undefined,
    };
}
exports.SKAdNetworkAttribution = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.skAdNetworkVersion !== "") {
            writer.uint32(26).string(message.skAdNetworkVersion);
        }
        if (message.skAdNetworkCampaignIdentifier !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.skAdNetworkCampaignIdentifier }, writer.uint32(34).fork()).ldelim();
        }
        if (message.skAdNetworkTimestampMs !== undefined) {
            wrappers_1.Int64Value.encode({ value: message.skAdNetworkTimestampMs }, writer.uint32(42).fork()).ldelim();
        }
        if (message.skAdNetworkNonce.length !== 0) {
            writer.uint32(50).bytes(message.skAdNetworkNonce);
        }
        if (message.skAdNetworkAttributionSignature.length !== 0) {
            writer.uint32(58).bytes(message.skAdNetworkAttributionSignature);
        }
        if (message.signatureContentTransformation !== 0) {
            writer.uint32(64).int32(message.signatureContentTransformation);
        }
        if (message.skAdNetworkViewThroughVersion !== "") {
            writer.uint32(74).string(message.skAdNetworkViewThroughVersion);
        }
        if (message.skAdNetworkViewThroughNonce.length !== 0) {
            writer.uint32(82).bytes(message.skAdNetworkViewThroughNonce);
        }
        if (message.skAdNetworkViewThroughAttributionSignature.length !== 0) {
            writer
                .uint32(90)
                .bytes(message.skAdNetworkViewThroughAttributionSignature);
        }
        if (message.skAdNetworkSourceIdentifier !== undefined) {
            wrappers_1.Int32Value.encode({ value: message.skAdNetworkSourceIdentifier }, writer.uint32(98).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseSKAdNetworkAttribution();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 3:
                    message.skAdNetworkVersion = reader.string();
                    break;
                case 4:
                    message.skAdNetworkCampaignIdentifier = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                case 5:
                    message.skAdNetworkTimestampMs = wrappers_1.Int64Value.decode(reader, reader.uint32()).value;
                    break;
                case 6:
                    message.skAdNetworkNonce = reader.bytes();
                    break;
                case 7:
                    message.skAdNetworkAttributionSignature = reader.bytes();
                    break;
                case 8:
                    message.signatureContentTransformation = reader.int32();
                    break;
                case 9:
                    message.skAdNetworkViewThroughVersion = reader.string();
                    break;
                case 10:
                    message.skAdNetworkViewThroughNonce = reader.bytes();
                    break;
                case 11:
                    message.skAdNetworkViewThroughAttributionSignature = reader.bytes();
                    break;
                case 12:
                    message.skAdNetworkSourceIdentifier = wrappers_1.Int32Value.decode(reader, reader.uint32()).value;
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseSKAdNetworkAttribution();
        message.skAdNetworkVersion = object.skAdNetworkVersion ?? "";
        message.skAdNetworkCampaignIdentifier =
            object.skAdNetworkCampaignIdentifier ?? undefined;
        message.skAdNetworkTimestampMs = object.skAdNetworkTimestampMs ?? undefined;
        message.skAdNetworkNonce = object.skAdNetworkNonce ?? new Uint8Array();
        message.skAdNetworkAttributionSignature =
            object.skAdNetworkAttributionSignature ?? new Uint8Array();
        message.signatureContentTransformation =
            object.signatureContentTransformation ?? 0;
        message.skAdNetworkViewThroughVersion =
            object.skAdNetworkViewThroughVersion ?? "";
        message.skAdNetworkViewThroughNonce =
            object.skAdNetworkViewThroughNonce ?? new Uint8Array();
        message.skAdNetworkViewThroughAttributionSignature =
            object.skAdNetworkViewThroughAttributionSignature ?? new Uint8Array();
        message.skAdNetworkSourceIdentifier =
            object.skAdNetworkSourceIdentifier ?? undefined;
        return message;
    },
};
function createBaseAdPosition() {
    return { index: 0, numBrandSafeSlots: 0, feedType: 0 };
}
exports.AdPosition = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.index !== 0) {
            writer.uint32(8).uint32(message.index);
        }
        if (message.numBrandSafeSlots !== 0) {
            writer.uint32(16).uint32(message.numBrandSafeSlots);
        }
        if (message.feedType !== 0) {
            writer.uint32(24).int32(message.feedType);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdPosition();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.index = reader.uint32();
                    break;
                case 2:
                    message.numBrandSafeSlots = reader.uint32();
                    break;
                case 3:
                    message.feedType = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdPosition();
        message.index = object.index ?? 0;
        message.numBrandSafeSlots = object.numBrandSafeSlots ?? 0;
        message.feedType = object.feedType ?? 0;
        return message;
    },
};
function createBaseAdMetadataCacheConfig() {
    return { adMetadataCacheTtlSecs: "0", adMetadataBackupCacheTtlSecs: "0" };
}
exports.AdMetadataCacheConfig = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.adMetadataCacheTtlSecs !== "0") {
            writer.uint32(8).int64(message.adMetadataCacheTtlSecs);
        }
        if (message.adMetadataBackupCacheTtlSecs !== "0") {
            writer.uint32(16).int64(message.adMetadataBackupCacheTtlSecs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseAdMetadataCacheConfig();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.adMetadataCacheTtlSecs = longToString(reader.int64());
                    break;
                case 2:
                    message.adMetadataBackupCacheTtlSecs = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseAdMetadataCacheConfig();
        message.adMetadataCacheTtlSecs = object.adMetadataCacheTtlSecs ?? "0";
        message.adMetadataBackupCacheTtlSecs =
            object.adMetadataBackupCacheTtlSecs ?? "0";
        return message;
    },
};
function createBaseOnDeviceInfo() {
    return {
        onDeviceMatchKey: new Uint8Array(),
        eventType: 0,
        dpParams: undefined,
        enableSidgExclusion: false,
        enableCanOpenUrlExclusion: false,
    };
}
exports.OnDeviceInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.onDeviceMatchKey.length !== 0) {
            writer.uint32(10).bytes(message.onDeviceMatchKey);
        }
        if (message.eventType !== 0) {
            writer.uint32(16).int32(message.eventType);
        }
        if (message.dpParams !== undefined) {
            exports.DifferentialPrivacyParameters.encode(message.dpParams, writer.uint32(26).fork()).ldelim();
        }
        if (message.enableSidgExclusion === true) {
            writer.uint32(32).bool(message.enableSidgExclusion);
        }
        if (message.enableCanOpenUrlExclusion === true) {
            writer.uint32(40).bool(message.enableCanOpenUrlExclusion);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseOnDeviceInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.onDeviceMatchKey = reader.bytes();
                    break;
                case 2:
                    message.eventType = reader.int32();
                    break;
                case 3:
                    message.dpParams = exports.DifferentialPrivacyParameters.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.enableSidgExclusion = reader.bool();
                    break;
                case 5:
                    message.enableCanOpenUrlExclusion = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseOnDeviceInfo();
        message.onDeviceMatchKey = object.onDeviceMatchKey ?? new Uint8Array();
        message.eventType = object.eventType ?? 0;
        message.dpParams =
            object.dpParams !== undefined && object.dpParams !== null
                ? exports.DifferentialPrivacyParameters.fromPartial(object.dpParams)
                : undefined;
        message.enableSidgExclusion = object.enableSidgExclusion ?? false;
        message.enableCanOpenUrlExclusion =
            object.enableCanOpenUrlExclusion ?? false;
        return message;
    },
};
function createBaseDifferentialPrivacyParameters() {
    return { tNoise: 0, tDp: 0, maxN: "0" };
}
exports.DifferentialPrivacyParameters = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.tNoise !== 0) {
            writer.uint32(13).float(message.tNoise);
        }
        if (message.tDp !== 0) {
            writer.uint32(21).float(message.tDp);
        }
        if (message.maxN !== "0") {
            writer.uint32(24).int64(message.maxN);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDifferentialPrivacyParameters();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.tNoise = reader.float();
                    break;
                case 2:
                    message.tDp = reader.float();
                    break;
                case 3:
                    message.maxN = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseDifferentialPrivacyParameters();
        message.tNoise = object.tNoise ?? 0;
        message.tDp = object.tDp ?? 0;
        message.maxN = object.maxN ?? "0";
        return message;
    },
};
function createBaseArResponsePayload() {
    return { precachedFirstLensId: [], responseExpirationTsMs: "0" };
}
exports.ArResponsePayload = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        writer.uint32(10).fork();
        for (const v of message.precachedFirstLensId) {
            writer.int64(v);
        }
        writer.ldelim();
        if (message.responseExpirationTsMs !== "0") {
            writer.uint32(80).int64(message.responseExpirationTsMs);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : new minimal_1.default.Reader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseArResponsePayload();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if ((tag & 7) === 2) {
                        const end2 = reader.uint32() + reader.pos;
                        while (reader.pos < end2) {
                            message.precachedFirstLensId.push(longToString(reader.int64()));
                        }
                    }
                    else {
                        message.precachedFirstLensId.push(longToString(reader.int64()));
                    }
                    break;
                case 10:
                    message.responseExpirationTsMs = longToString(reader.int64());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromPartial(object) {
        const message = createBaseArResponsePayload();
        message.precachedFirstLensId =
            object.precachedFirstLensId?.map((e) => e) || [];
        message.responseExpirationTsMs = object.responseExpirationTsMs ?? "0";
        return message;
    },
};
function longToString(long) {
    return long.toString();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=ad_response.js.map